import { __decorate, __metadata } from "tslib";
import { IsArray, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { UUID_VERSION } from '../../type/shared';
import { UserGroupPermissionId } from '../user-group';
export class CheckAnyPermissionQuery {
}
__decorate([
    IsArray(),
    IsEnum(UserGroupPermissionId, { each: true }),
    __metadata("design:type", Array)
], CheckAnyPermissionQuery.prototype, "userGroupPermissionIds", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CheckAnyPermissionQuery.prototype, "resourceType", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsUUID(UUID_VERSION, { each: true }),
    __metadata("design:type", Object)
], CheckAnyPermissionQuery.prototype, "resourceIds", void 0);
